import { Switch, Typography } from '@mui/material';
import { useInitialOnboardingComplete } from '../../../services/entities/hooks/settings/useInitialOnboardingComplete';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { MenuPaper } from '../../commonUI/Menu/MenuPaper';
import { SettingsMenuRow } from '../components/SettingsMenuRow';

export const DeveloperSettings = () => {
  const { t } = useTranslation();

  const { initialOnboardingComplete, setInitialOnboardingComplete } =
    useInitialOnboardingComplete();

  const handleOnboardingCompleteChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setInitialOnboardingComplete(event.target.checked);
  };
  return (
    <MenuPaper>
      <SettingsMenuRow>
        <Typography>{t('Initial user onboarding complete?')}</Typography>
        <Switch
          checked={initialOnboardingComplete}
          onChange={handleOnboardingCompleteChange}
        />
      </SettingsMenuRow>
    </MenuPaper>
  );
};
